var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5055 19.1193C10.1772 19.2459 9.81362 19.2459 9.48538 19.1193C6.92416 18.1359 4.72148 16.3989 3.16829 14.1373C1.61509 11.8758 0.784474 9.19639 0.786135 6.4529V2.20246C0.786135 1.8267 0.935405 1.46632 1.20111 1.20062C1.46682 0.934916 1.82719 0.785645 2.20295 0.785645H17.7879C18.1636 0.785645 18.5241 0.934916 18.7898 1.20062C19.0555 1.46632 19.2048 1.8267 19.2048 2.20246V6.4529C19.2063 9.19639 18.3758 11.8758 16.8226 14.1373C15.2693 16.3989 13.0667 18.1359 10.5055 19.1193Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2863 5.71436L8.57199 12.1429L5.71484 10.0001",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.25c4dcf88ada0a08e7d63ed308372d95.svg";
export { ForwardRef as ReactComponent };